import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		flex: 1,
	},
	placeholderClearButton: {
		color: '#8E8E8E',
		marginTop: 14,
	},
	placeholderMessage: {
		color: '#4A4A4A',
		fontSize: 14,
		lineHeight: '22px',
		marginTop: 20,
	},
});
